
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/switch/switch.component.js'
      import type { DdsChangeEvent } from '../../events/events'
import type { DdsBlurEvent } from '../../events/events'
import type { DdsFocusEvent } from '../../events/events'
import type { DdsInputEvent } from '../../events/events'
      export type { DdsChangeEvent } from '../../events/events'
export type { DdsBlurEvent } from '../../events/events'
export type { DdsFocusEvent } from '../../events/events'
export type { DdsInputEvent } from '../../events/events'

      const tagName = 'dap-ds-switch'

      /**
 * `dap-ds-switch`
 * @summary A switch is a graphical control element that allows the user to toggle between two states.
 * @element dap-ds-switch
 * @title - Switch
 *
 * @property {string} name - The name of the switch.
 * @property {string} value - The value of the switch.
 * @property {string} label - The label of the switch.
 * @property {string} description - The description of the switch.
 * @property {boolean} checked - The checked state of the switch.
 * @property {'xs' | 'sm' | 'lg'} size - The size of the switch.
 * @property {boolean} disabled - The disabled state of the switch.
 * @property {boolean} readonly - Whether the switch is readonly (cannot be changed but value is submitted with form).
 * @property {boolean} required - The required state of the switch.
 * @property {'left' | 'right'} labelPlacement - The placement of the label.
 * @property {'top' | 'bottom'} descriptionPlacement - The placement of the description.
 * @property {boolean} subtle - The weight of the label.
 * @property {string} feedback - The feedback of the switch.
 * @property {'negative' | 'positive' | 'warning'} feedbackType - The feedback type of the switch.
 * @property {boolean} optional - The optional state of the switch.
 * @property {string} optionalLabel - The optional label of the switch.
 *
 * @cssProperty --dds-switch-width - Width of the switch control.
 * @cssProperty --dds-switch-height - Height of the switch control.
 * @cssProperty --dds-switch-thumb-width - Width of the switch thumb.
 * @cssProperty --dds-switch-thumb-height - Height of the switch thumb.
 * @cssProperty --dds-switch-thumb-margin - Margin around the switch thumb.
 * @cssProperty --dds-switch-thumb-color - Color of the switch thumb.
 * @cssProperty --dds-switch-unchecked-bg - Background color of the switch when unchecked.
 * @cssProperty --dds-switch-checked-bg - Background color of the switch when checked.
 * @cssProperty --dds-switch-invalid-bg - Background color of the switch when invalid.
 * @cssProperty --dds-switch-disabled-bg - Background color of the switch when disabled.
 * @cssProperty --dds-switch-wrapper-padding - Padding of the switch wrapper.
 * @cssProperty --dds-switch-wrapper-bg - Background color of the switch wrapper.
 * @cssProperty --dds-switch-border-color - Border color of the switch.
 * @cssProperty --dds-switch-high-contrast-border-color - Border color of the switch in high contrast mode.
 *
 * @event {{ value: string }} dds-change - Fired when the input value changes.
 * @event {{ void }} dds-blur - Emitted when the input loses focus.
 * @event {{ void }} dds-focus - Emitted when the input gains focus.
 * @event {{ value: string }} dds-input - Emitted when the input receives input.
 *
 * @csspart base - The main switch container.
 * @csspart baselabel - The main label container
 * @csspart label - The label of the switch.
 * @csspart input - The native input of the switch.
 * @csspart control - The control of the switch.
 * @csspart description - The description of the switch.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsChange: 'dds-change' as EventName<DdsChangeEvent>,
onDdsBlur: 'dds-blur' as EventName<DdsBlurEvent>,
onDdsFocus: 'dds-focus' as EventName<DdsFocusEvent>,
onDdsInput: 'dds-input' as EventName<DdsInputEvent>
        },
        displayName: "DapDSSwitch"
      })

      export default reactWrapper
    